import {InjectionToken, InputSignal, Type} from '@angular/core';

export interface SearchResultComponent<T> {
  result: InputSignal<T>;
}

export const SOFTLINE_CONFIG_SEARCH_PAGE_RESULT_VIEW = new InjectionToken<Type<SearchResultComponent<any>>>(
  'SOFTLINE_CONFIG_SEARCH_PAGE_RESULT_VIEW'
);
